"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[478],{

/***/ 56083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var _air_marketing_primitives__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89170);

var Container = (0,_air_marketing_primitives__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    maxWidth: 1224,
    marginX: "auto",
    paddingX: 32,
    boxSizing: "border-box"
});


/***/ }),

/***/ 10622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ Logo; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/primitives/src/index.tsx + 20 modules
var src = __webpack_require__(89170);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/old-marketing/components/globals/Logo.styles.ts

var Root = (0,src/* styled */.zo)("a", {
    display: "inline-block",
    height: 24,
    svg: {
        display: "block",
        height: "100%"
    }
});

// EXTERNAL MODULE: ./src/old-marketing/constants/Routes.ts
var Routes = __webpack_require__(46955);
// EXTERNAL MODULE: ./src/old-marketing/constants/testIds.ts
var testIds = __webpack_require__(50580);
;// CONCATENATED MODULE: ./src/old-marketing/components/globals/Logo.tsx






var Logo = function(param) {
    var css = param.css, _href = param.href, href = _href === void 0 ? Routes/* Routes.root */.Z5.root : _href;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Root, {
            css: css,
            "data-testid": testIds/* LOGO */.us,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* VisuallyHidden */.TX, {
                    children: "Air"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    fill: "currentColor",
                    viewBox: "0 0 350 144",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        fillRule: "evenodd",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M147.617 58.488c2.45-12.67 3.492-23.619 3.492-29.919C151.109 4.956 140.365 0 131.353 0c-19.144 0-46.195 22.141-82.697 67.69-26.076 32.537-47.432 65.52-47.644 65.848a6.312 6.312 0 001.878 8.73 6.313 6.313 0 008.729-1.88c31.903-49.395 92.62-127.76 119.734-127.76 2.133 0 7.127 0 7.127 15.941 0 6.227-1.14 17.313-3.735 29.957 0 0 7.343-.247 12.872-.038M222.43 46.512c0 5.486-4.448 9.934-9.935 9.934-5.486 0-9.933-4.448-9.933-9.934 0-5.486 4.447-9.934 9.933-9.934 5.487 0 9.934 4.448 9.934 9.934"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M251.376 92.738A114.675 114.675 0 01240 106.315c-15.33 15.69-33.125 25.056-47.6 25.056-7.453 0-11.232-3.186-11.232-9.47 0-6.645 3.645-19.298 21.007-41.839a6.317 6.317 0 00.874-6.162 6.318 6.318 0 00-4.835-3.918l-.005.005.005-.032C155.506 62.806 98.435 59.5 69.084 84.343v.028c-14.632 12.386-15.769 26.242-15.769 30.193 0 16.771 12.775 29.416 29.715 29.416 23.02 0 41.912-17.346 54.635-50.16a178.444 178.444 0 003.562-10.148c-4.67.008-9.163.167-13.443.471-8.538 24.562-22.77 47.208-44.754 47.208-11.217 0-17.086-8.444-17.086-16.787 0-5.312 2.968-13.502 11.3-20.555v-.027C90.721 82.574 120.5 71.41 185.925 80.832c-11.674 16.66-17.385 30.171-17.385 41.07 0 16.311 12.854 22.098 23.86 22.098 18.07 0 38.711-10.519 56.633-28.859 5.863-6 10.964-12.365 15.165-18.795-8.24-.465-12.822-3.608-12.822-3.608"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M348.148 112.738a6.313 6.313 0 00-8.911-.57c-13.861 12.191-28.13 19.183-39.145 19.183-6.54 0-9.855-3.423-9.855-10.175 0-7.297 3.914-21.077 22.555-45.278a6.316 6.316 0 00-8.602-9.04l-.001.001v-.002c-9.404 6.526-23.156 10.91-34.221 10.91-14.007 0-20.388-8.516-20.388-16.43 0-9.635 4.978-12.18 7.61-12.18 6.767 0 7.467 7.511 7.52 9.813.079 3.452-.551 7.291-1.782 11.353 0 0 6.119 2.153 12.876.698 1.083-4.318 1.62-8.47 1.53-12.343-.301-13.042-8.584-22.15-20.143-22.15-10.058 0-20.24 8.522-20.24 24.81 0 8.815 3.835 16.61 10.796 21.945 5.984 4.587 13.876 7.112 22.22 7.112 6.21 0 12.962-1.07 19.564-2.993l-.001.001c-7.923 13.21-11.921 24.52-11.921 33.773 0 15.753 11.292 22.804 22.483 22.804 19.226 0 38.003-13.99 47.486-22.33a6.312 6.312 0 00.57-8.912"
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 64774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ DefaultFooter; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/primitives/src/index.tsx + 20 modules
var src = __webpack_require__(89170);
// EXTERNAL MODULE: ./src/old-marketing/components/globals/Container.tsx
var Container = __webpack_require__(56083);
;// CONCATENATED MODULE: ./src/old-marketing/components/globals/footers/DefaultFooter.styles.ts

var Root = (0,src/* styled */.zo)("footer", {
    backgroundColor: "$pigeon025",
    paddingY: 40,
    "@laptop": {
        paddingY: 80
    }
});
var Info = (0,src/* styled */.zo)("div", {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "row",
    flexGrow: 1,
    flexShrink: 0,
    marginRight: 24,
    justifyContent: "space-between",
    "@laptop": {
        flexDirection: "column",
        justifyContent: "flex-start"
    }
});
var NavigationContainer = (0,src/* styled */.zo)("div", {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "unset",
    "@laptop": {
        flexDirection: "nowrap",
        maxWidth: 900
    }
});
var Navigation = (0,src/* styled */.zo)("nav", {
    display: "flex",
    flexDirection: "column",
    width: "calc(50% - 24px)",
    marginRight: 24,
    marginBottom: 24,
    "@laptop": {
        width: "auto",
        marginBottom: 24
    }
});

// EXTERNAL MODULE: ./src/old-marketing/components/globals/Logo.tsx + 1 modules
var Logo = __webpack_require__(10622);
// EXTERNAL MODULE: ../../packages/analytics/src/index.ts + 42 modules
var analytics_src = __webpack_require__(64043);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/old-marketing/constants/Routes.ts
var Routes = __webpack_require__(46955);
// EXTERNAL MODULE: ./src/old-marketing/constants/testIds.ts
var testIds = __webpack_require__(50580);
;// CONCATENATED MODULE: ./src/old-marketing/components/primitives/Link.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var sharedLinkCSS = {
    display: "inline-flex",
    alignItems: "center",
    color: "$macaw350",
    fontWeight: "$medium",
    textDecoration: "none",
    "&:hover": {
        textDecoration: "underline"
    }
};
var Link = function(param) {
    var children = param.children, css = param.css, _href = param.href, href = _href === void 0 ? Routes/* Routes.root */.Z5.root : _href, _onClick = param.onClick, onClick = _onClick === void 0 ? lodash.noop : _onClick, _passHref = param.passHref, passHref = _passHref === void 0 ? true : _passHref, size = param.size, transform = param.transform, _type = param.type, type = _type === void 0 ? "internal" : _type;
    var trackClickedActionItem = (0,analytics_src/* useTrackClickedActionItem */.Nw)().trackClickedActionItem;
    var isExternal = type === "external";
    var onLinkClick = function(event) {
        trackClickedActionItem({
            location: window.location.href,
            destination: href,
            destinationType: type
        });
        onClick(event);
    };
    if (isExternal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Text */.xv, {
            as: "a",
            css: _objectSpread({}, sharedLinkCSS, css),
            "data-testid": testIds/* LINK */.Zj,
            href: href,
            onClick: onLinkClick,
            size: size,
            target: "_blank",
            transform: transform,
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: passHref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Text */.xv, {
            as: "a",
            css: _objectSpread({}, sharedLinkCSS, css),
            "data-testid": testIds/* LINK */.Zj,
            onClick: onLinkClick,
            size: size,
            transform: transform,
            children: children
        })
    });
};

// EXTERNAL MODULE: ./src/old-marketing/constants/navigation.tsx + 4 modules
var navigation = __webpack_require__(47181);
;// CONCATENATED MODULE: ./src/old-marketing/components/globals/footers/DefaultFooter.tsx









var DefaultFooter = function(param) {
    var css = param.css;
    var currentYear = new Date().getFullYear();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Root, {
        css: css,
        "data-testid": testIds/* FOOTER */.lW,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                css: {
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: 24,
                    "@laptop": {
                        flexDirection: "row",
                        marginBottom: 48
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* Logo */.T, {
                                css: {
                                    fill: "jay900",
                                    height: 32,
                                    marginBottom: 24
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Box */.xu, {
                                css: {
                                    display: "flex",
                                    flexDirection: "row",
                                    "@laptop": {
                                        flexDirection: "column"
                                    }
                                },
                                children: navigation/* FOOTER_SOCIAL_NAVIGATION.map */.bW.map(function(navigationItem, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link, {
                                        css: {
                                            marginBottom: 16,
                                            color: "$pigeon700"
                                        },
                                        href: navigationItem.href,
                                        size: "ui-14",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Box */.xu, {
                                                as: navigationItem.icon,
                                                css: {
                                                    display: "block",
                                                    width: 24,
                                                    marginLeft: 12,
                                                    marginRight: 0,
                                                    "@laptop": {
                                                        marginLeft: 0,
                                                        marginRight: 8
                                                    }
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Box */.xu, {
                                                as: "span",
                                                css: {
                                                    display: "none",
                                                    "@laptop": {
                                                        display: "inline"
                                                    }
                                                },
                                                children: navigationItem.label
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationContainer, {
                        children: navigation/* FOOTER_NAVIGATION.map */.W5.map(function(column, index1) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navigation, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Text */.xv, {
                                        as: "h2",
                                        css: {
                                            marginBottom: 24,
                                            color: "$pigeon800",
                                            fontWeight: "$semibold"
                                        },
                                        id: column.title,
                                        size: {
                                            "@initial": "ui-14",
                                            "@laptop": "ui-20"
                                        },
                                        children: column.title
                                    }),
                                    column.items.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                            css: {
                                                marginBottom: 16,
                                                color: "$pigeon700"
                                            },
                                            href: item.href,
                                            type: item.type,
                                            size: "ui-14",
                                            children: item.label
                                        }, index);
                                    })
                                ]
                            }, index1);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* Text */.xv, {
                    css: {
                        width: "calc(100% - 93px)",
                        color: "$jay900"
                    },
                    size: {
                        "@initial": "ui-12",
                        "@laptop": "ui-14"
                    },
                    children: [
                        "Copyright \xa9 ",
                        currentYear,
                        " Air, Inc. All rights reserved.",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                            href: Routes/* Routes.terms */.Z5.terms,
                            css: {
                                fontSize: "inherit"
                            },
                            children: "Terms"
                        }),
                        " & ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                            href: Routes/* Routes.privacy */.Z5.privacy,
                            css: {
                                fontSize: "inherit"
                            },
                            children: "Privacy"
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 47181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W5": function() { return /* binding */ FOOTER_NAVIGATION; },
  "bW": function() { return /* binding */ FOOTER_SOCIAL_NAVIGATION; },
  "uT": function() { return /* binding */ HEADER_NAVIGATION; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@air/icons/dist/icons.esm.js
var icons_esm = __webpack_require__(74398);
// EXTERNAL MODULE: ../../packages/primitives/src/index.tsx + 20 modules
var src = __webpack_require__(89170);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMenuBanner.styles.ts

var Root = (0,src/* styled */.zo)("div", {
    display: "flex"
});

;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMenuBanner.tsx




var HeaderMenuBanner = function(param) {
    var css = param.css, cta = param.cta, description = param.description, image = param.image, isDemo = param.isDemo, _onDemoDialogOpen = param.onDemoDialogOpen, onDemoDialogOpen = _onDemoDialogOpen === void 0 ? lodash.noop : _onDemoDialogOpen, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Root, {
            css: css,
            children: [
                image && /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Box */.xu, {
                    css: {
                        flexShrink: 0,
                        marginRight: 16
                    },
                    children: image
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* Box */.xu, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Text */.xv, {
                            css: {
                                marginBottom: 4,
                                color: "$pigeon900",
                                fontWeight: "$semibold"
                            },
                            size: "ui-20",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Text */.xv, {
                            css: {
                                color: "$pigeon900"
                            },
                            size: "ui-14",
                            children: description
                        }),
                        cta && /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Box */.xu, {
                            css: {
                                marginTop: 16
                            },
                            onClick: isDemo ? onDemoDialogOpen : undefined,
                            children: cta
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMenuItemAdornment.styles.ts

var HeaderMenuItemAdornment_styles_Root = (0,src/* styled */.zo)("div", {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 44,
    height: 44,
    borderRadius: 4,
    color: "$jay300",
    variants: {
        size: {
            large: {
                width: 44,
                height: 44
            },
            small: {
                width: 32,
                height: 32
            }
        }
    },
    defaultVariants: {
        size: "large"
    }
});

// EXTERNAL MODULE: ./src/old-marketing/constants/testIds.ts
var testIds = __webpack_require__(50580);
;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMenuItemAdornment.tsx




var HeaderMenuItemAdornment = function(param) {
    var children = param.children, css = param.css, size = param.size;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment_styles_Root, {
        css: css,
        "data-testid": testIds/* HEADER_MENU_ITEM_ADORNMENT */.E_,
        size: size,
        children: children
    });
};

// EXTERNAL MODULE: ./src/old-marketing/constants/Routes.ts
var Routes = __webpack_require__(46955);
;// CONCATENATED MODULE: ./src/old-marketing/constants/navigation.tsx








var HEADER_NAVIGATION = [
    {
        name: "Product",
        color: "#F0F3FF",
        columns: [
            {
                name: "Features",
                chunkSize: 4,
                items: [
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Dart */.f8k, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Smart search",
                        description: "We auto-tag your content",
                        href: Routes/* Routes.featuresSmartSearch */.Z5.featuresSmartSearch
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Palette */.YIH, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Dynamic feedback",
                        description: "Timestamp and point-based comments",
                        href: Routes/* Routes.featuresDynamicFeedback */.Z5.featuresDynamicFeedback
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Kanban */.pt$, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Kanban",
                        description: "Organize assets for your workflow",
                        href: Routes/* Routes.featuresKanban */.Z5.featuresKanban
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Stack */.Kqy, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Versions",
                        description: "Every asset is a folder for its own drafts",
                        href: Routes/* Routes.featuresVersions */.Z5.featuresVersions
                    }, 
                ]
            },
            {
                name: "",
                chunkSize: 4,
                css: {
                    marginTop: 20
                },
                items: [
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Move */.A6R, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Flexible organization",
                        description: "Customize your workspace",
                        href: Routes/* Routes.featuresFlexibleOrganization */.Z5.featuresFlexibleOrganization
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Eye */.bAj, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Visual workspace",
                        description: "See all of your assets clearly",
                        href: Routes/* Routes.featuresVisualWorkspace */.Z5.featuresVisualWorkspace
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Device */.ASe, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Mobile and desktop apps",
                        description: "Simple, fast uploads from your devices to Air",
                        href: Routes/* Routes.download */.Z5.download
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Link */.rUS, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Integrations",
                        description: "Seamlessly integrate Air with your favorite tools",
                        href: Routes/* Routes.integrations */.Z5.integrations
                    }, 
                ]
            },
            {
                name: "see air in action",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuBanner, {
                    description: "We\u2019ll show you how Air can put time back in your day",
                    image: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: "",
                        height: 161,
                        src: "/assets/marketing/header-menu-product.svg",
                        width: 160
                    }),
                    isDemo: true,
                    cta: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Text */.xv, {
                        as: "a",
                        css: {
                            color: "$jay350",
                            fontWeight: "$medium",
                            textDecoration: "none",
                            cursor: "pointer"
                        },
                        size: "ui-14",
                        children: "Book a demo \u2192"
                    }),
                    title: "Talk to a human"
                })
            }, 
        ],
        template: "product"
    },
    {
        name: "Customers",
        color: "$canary050",
        columns: [
            {
                name: "By industry",
                chunkSize: 3,
                hasDivider: true,
                items: [
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            css: {
                                backgroundColor: "$cuckoo100",
                                color: "$cuckoo600"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Cart */.APc, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "E-commerce & DTC",
                        description: "Centralize retail & marketing work",
                        href: Routes/* Routes.industryRetail */.Z5.industryRetail
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            css: {
                                backgroundColor: "$peacock300",
                                color: "$peacock700"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Megaphone */.Jo6, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Agencies",
                        description: "Create a workspace for each client relationship",
                        href: Routes/* Routes.industryAgencies */.Z5.industryAgencies
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            css: {
                                backgroundColor: "$canary300",
                                color: "$canary700"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Popcorn */.yq8, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Media & Entertainment",
                        description: "Build a central library for all your visuals",
                        href: Routes/* Routes.industryMedia */.Z5.industryMedia
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            css: {
                                backgroundColor: "$parrot050",
                                color: "$parrot600"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Home */.SK8, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Non-profits",
                        description: "Spend less time in the weeds, more time doing good work",
                        href: Routes/* Routes.industryNonprofits */.Z5.industryNonprofits
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            css: {
                                backgroundColor: "$macaw040",
                                color: "$macaw350"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Soccer */.jJO, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Athletics & Sports",
                        description: "Every photo and video, stored and easily shareable",
                        href: Routes/* Routes.industryAthletics */.Z5.industryAthletics
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            css: {
                                backgroundColor: "$flamingo200",
                                color: "$flamingo800"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Apple */.ACs, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Education ",
                        href: Routes/* Routes.industryEducation */.Z5.industryEducation,
                        description: "Store and distribute visuals easily"
                    }, 
                ]
            },
            {
                name: "By team",
                chunkSize: 4,
                items: [
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Dart */.f8k, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Marketing",
                        description: "Accelerate campaign management",
                        href: Routes/* Routes.departmentMarketing */.Z5.departmentMarketing
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Palette */.YIH, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Creative",
                        description: "Spend more time creating & less time organizing",
                        href: Routes/* Routes.departmentDesignCreative */.Z5.departmentDesignCreative
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Kanban */.pt$, {
                                className: "block w-6 rotate-180"
                            })
                        }),
                        name: "Enterprise",
                        description: "Security, services and pricing for scale",
                        href: Routes/* Routes.enterprise */.Z5.enterprise
                    }, 
                ]
            },
            {
                name: "Customer stories",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuBanner, {
                    cta: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: Routes/* Routes.customerStories */.Z5.customerStories,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Text */.xv, {
                            as: "a",
                            css: {
                                color: "$jay350",
                                fontWeight: "$medium",
                                textDecoration: "none"
                            },
                            size: "ui-14",
                            children: "Learn more \u2192"
                        })
                    }),
                    description: "Read how Air saves teams time and headaches",
                    image: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: "product image",
                        height: 161,
                        src: "/blog/assets/header-menu-enterprise.svg",
                        width: 160
                    }),
                    title: "Top brands love Air"
                })
            }, 
        ],
        template: "enterprise"
    },
    {
        name: "Learn",
        color: "$peacock100",
        columns: [
            {
                name: "Switch from",
                chunkSize: 4,
                items: [
                    {
                        name: "Dropbox",
                        href: Routes/* Routes.comparisonDropboxAlternative */.Z5.comparisonDropboxAlternative
                    },
                    {
                        name: "Google Drive",
                        href: Routes/* Routes.comparisonGoogleDriveAlternative */.Z5.comparisonGoogleDriveAlternative
                    },
                    {
                        name: "Box",
                        href: Routes/* Routes.comparisonBox */.Z5.comparisonBox
                    },
                    {
                        name: "DAM",
                        href: Routes/* Routes.comparisonDAM */.Z5.comparisonDAM
                    }, 
                ]
            },
            {
                name: "Resources",
                chunkSize: 4,
                hasDivider: true,
                items: [
                    {
                        name: "Help center",
                        href: Routes/* SharedRoutes.helpCenter */.qh.helpCenter
                    },
                    {
                        name: "Status page",
                        href: Routes/* SharedRoutes.status */.qh.status
                    },
                    {
                        name: "Security",
                        href: Routes/* Routes.security */.Z5.security
                    },
                    {
                        name: "Release notes",
                        href: Routes/* Routes.releaseNotes */.Z5.releaseNotes
                    }, 
                ]
            },
            {
                name: "Blog",
                chunkSize: 5,
                items: [
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* NavBlog */.Wpw, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Blog homepage",
                        href: Routes/* Routes.blog */.Z5.blog
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Palette */.YIH, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Creative ops",
                        href: Routes/* BlogRoutes.creativeOps */.A0.creativeOps
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* MagicWand */.nus, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Building brands",
                        href: Routes/* BlogRoutes.buildingBrands */.A0.buildingBrands
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Email */.GTk, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Air news",
                        href: Routes/* BlogRoutes.airNews */.A0.airNews
                    }, 
                ]
            },
            {
                name: "Air does it better",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuBanner, {
                    cta: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/landing/sem-lp-gated-buyout-4",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Text */.xv, {
                            as: "a",
                            css: {
                                color: "$jay350",
                                fontWeight: "$medium",
                                textDecoration: "none"
                            },
                            size: "ui-14",
                            children: "Learn more \u2192"
                        })
                    }),
                    description: "Switch to Air and we\u2019ll buy out your contract",
                    image: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            alt: "",
                            height: 151,
                            src: "/assets/marketing/header-menu-enterprise.svg",
                            width: 150
                        })
                    }),
                    title: "DAM not your jam?"
                })
            }, 
        ],
        template: "resources"
    },
    {
        name: "Why Air?",
        color: "$peacock100",
        columns: [
            {
                name: "Use cases",
                chunkSize: 4,
                items: [
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            css: {
                                backgroundColor: "$macaw060",
                                color: "$macaw500"
                            },
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Team */.SZ7, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "External collaboration",
                        href: Routes/* Routes.tourOnboardFreelancers */.Z5.tourOnboardFreelancers
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            css: {
                                backgroundColor: "$peacock300",
                                color: "$peacock700"
                            },
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Check */.JrY, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Creative approvals",
                        href: Routes/* Routes.tourCreativeApprovals */.Z5.tourCreativeApprovals
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            css: {
                                backgroundColor: "$flamingo200",
                                color: "$canary800"
                            },
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Lock */.HEZ, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Usage & access",
                        href: Routes/* Routes.tourRightsManagement */.Z5.tourRightsManagement
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            css: {
                                backgroundColor: "$canary300",
                                color: "$flamingo900"
                            },
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Send */.vw7, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Project management",
                        href: Routes/* Routes.tourCreativeRequests */.Z5.tourCreativeRequests
                    }, 
                ]
            },
            {
                name: "Company",
                chunkSize: 5,
                hasDivider: true,
                items: [
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Info */.kIV, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "About us",
                        href: Routes/* Routes.about */.Z5.about
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* MagnifyingGlass */.YtI, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Careers",
                        href: Routes/* Routes.careers */.Z5.careers
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Emoji */.dyV, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Investors",
                        href: Routes/* Routes.operators */.Z5.operators
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Cart */.APc, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Air merch",
                        href: Routes/* Routes.airShop */.Z5.airShop
                    }, 
                ]
            },
            {
                name: "Life at Air",
                items: [
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* NavCulture */.t3z, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Culture",
                        href: Routes/* Routes.culture */.Z5.culture
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* NavDiversity */.jNn, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Diversity",
                        href: Routes/* Routes.diversity */.Z5.diversity
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* Team */.SZ7, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Inclusion",
                        href: Routes/* Routes.inclusion */.Z5.inclusion
                    },
                    {
                        adornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItemAdornment, {
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_esm/* NavPolicies */.nuZ, {
                                className: "block w-6 h-6"
                            })
                        }),
                        name: "Policies",
                        href: Routes/* Routes.culturePolicies */.Z5.culturePolicies
                    }, 
                ]
            },
            {
                name: "Join our team",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuBanner, {
                    description: "We\u2019re growing fast and always hiring",
                    image: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "m-[100px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            alt: "air product",
                            height: 151,
                            src: "/blog/assets/header-menu-resources.svg",
                            width: 150
                        })
                    }),
                    cta: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Text */.xv, {
                        as: "a",
                        css: {
                            color: "$jay350",
                            fontWeight: "$medium",
                            textDecoration: "none"
                        },
                        href: Routes/* Routes.careers */.Z5.careers,
                        size: "ui-14",
                        children: "Learn more \u2192"
                    }),
                    title: "Explore open roles"
                })
            }, 
        ],
        template: "why-air"
    },
    {
        name: "Pricing",
        href: Routes/* Routes.pricing */.Z5.pricing
    }, 
];
var FOOTER_NAVIGATION = [
    {
        title: "Product",
        items: [
            {
                label: "Smart search",
                href: Routes/* Routes.featuresSmartSearch */.Z5.featuresSmartSearch,
                type: "internal"
            },
            {
                label: "Dynamic feedback",
                href: Routes/* Routes.featuresDynamicFeedback */.Z5.featuresDynamicFeedback,
                type: "internal"
            },
            {
                label: "Kanban",
                href: Routes/* Routes.featuresKanban */.Z5.featuresKanban,
                type: "internal"
            },
            {
                label: "Versions",
                href: Routes/* Routes.featuresVersions */.Z5.featuresVersions,
                type: "internal"
            },
            {
                label: "Flexible organization",
                href: Routes/* Routes.flexibleOrganization */.Z5.flexibleOrganization,
                type: "internal"
            },
            {
                label: "Visual workspace",
                href: Routes/* Routes.visualWorkspace */.Z5.visualWorkspace,
                type: "internal"
            },
            {
                label: "Desktop app",
                href: Routes/* Routes.airFlow */.Z5.airFlow,
                type: "internal"
            },
            {
                label: "Mobile apps",
                href: Routes/* Routes.download */.Z5.download,
                type: "internal"
            },
            {
                label: "Integrations ",
                href: Routes/* Routes.integrations */.Z5.integrations,
                type: "internal"
            },
            {
                label: "Pricing",
                href: Routes/* Routes.pricing */.Z5.pricing,
                type: "internal"
            }, 
        ],
        css: {
            order: 1
        }
    },
    {
        title: "Customers",
        items: [
            {
                label: "Customer stories",
                href: Routes/* Routes.customerStories */.Z5.customerStories,
                type: "internal"
            },
            {
                label: "E-commerce & DTC ",
                href: Routes/* Routes.industryRetail */.Z5.industryRetail,
                type: "internal"
            },
            {
                label: "Agencies",
                href: Routes/* Routes.industryAgencies */.Z5.industryAgencies,
                type: "internal"
            },
            {
                label: "Media & Entertainment",
                href: Routes/* Routes.industryMedia */.Z5.industryMedia,
                type: "internal"
            },
            {
                label: "Non-profits",
                href: Routes/* Routes.industryNonprofits */.Z5.industryNonprofits,
                type: "internal"
            },
            {
                label: "Athletics & Sports",
                href: Routes/* Routes.industryAthletics */.Z5.industryAthletics,
                type: "internal"
            },
            {
                label: "Education",
                href: Routes/* Routes.industryEducation */.Z5.industryEducation,
                type: "internal"
            },
            {
                label: "Marketing",
                href: Routes/* Routes.departmentMarketing */.Z5.departmentMarketing,
                type: "internal"
            },
            {
                label: "Creative",
                href: Routes/* Routes.departmentDesignCreative */.Z5.departmentDesignCreative,
                type: "internal"
            },
            {
                label: "Enterprise",
                href: Routes/* Routes.enterprise */.Z5.enterprise,
                type: "internal"
            }, 
        ],
        css: {
            order: 2
        }
    },
    {
        title: "Solutions",
        items: [
            {
                label: "Dropbox alternative",
                href: Routes/* Routes.comparisonDropboxAlternative */.Z5.comparisonDropboxAlternative,
                type: "internal"
            },
            {
                label: "Google Drive alternative",
                href: Routes/* Routes.comparisonGoogleDriveAlternative */.Z5.comparisonGoogleDriveAlternative,
                type: "internal"
            },
            {
                label: "Box alternative ",
                href: Routes/* Routes.comparisonBox */.Z5.comparisonBox,
                type: "internal"
            },
            {
                label: "DAM alternative",
                href: Routes/* Routes.comparisonDAM */.Z5.comparisonDAM,
                type: "internal"
            },
            {
                label: "External collaboration",
                href: Routes/* Routes.tourOnboardFreelancers */.Z5.tourOnboardFreelancers,
                type: "internal"
            },
            {
                label: "Usage & access",
                href: Routes/* Routes.tourRightsManagement */.Z5.tourRightsManagement,
                type: "internal"
            },
            {
                label: "Project management",
                href: Routes/* Routes.tourCreativeRequests */.Z5.tourCreativeRequests,
                type: "internal"
            }, 
        ],
        css: {
            order: 3
        }
    },
    {
        title: "Resources",
        items: [
            {
                label: "Help center",
                href: Routes/* SharedRoutes.helpCenter */.qh.helpCenter,
                type: "internal"
            },
            {
                label: "Blog",
                href: Routes/* Routes.blog */.Z5.blog,
                type: "internal"
            },
            {
                label: "Live events",
                href: Routes/* Routes.liveEvents */.Z5.liveEvents,
                type: "internal"
            },
            {
                label: "Release notes",
                href: Routes/* Routes.releaseNotes */.Z5.releaseNotes,
                type: "external"
            },
            {
                label: "Status",
                href: Routes/* SharedRoutes.status */.qh.status,
                type: "external"
            },
            {
                label: "Security",
                href: Routes/* Routes.security */.Z5.security,
                type: "internal"
            },
            {
                label: "Beta program",
                href: Routes/* Routes.betaProgram */.Z5.betaProgram,
                type: "internal"
            }, 
        ],
        css: {
            order: 4
        }
    },
    {
        title: "Company",
        items: [
            {
                label: "About us",
                href: Routes/* Routes.about */.Z5.about,
                type: "internal"
            },
            {
                label: "Careers",
                href: Routes/* Routes.careers */.Z5.careers,
                type: "external"
            },
            {
                label: "Partner program",
                href: Routes/* Routes.partnerProgram */.Z5.partnerProgram,
                type: "external"
            },
            {
                label: "Investors",
                href: Routes/* Routes.operators */.Z5.operators,
                type: "external"
            },
            {
                label: "Culture",
                href: Routes/* Routes.culture */.Z5.culture,
                type: "internal"
            },
            {
                label: "Diversity",
                href: Routes/* Routes.diversity */.Z5.diversity,
                type: "internal"
            },
            {
                label: "Inclusion",
                href: Routes/* Routes.inclusion */.Z5.inclusion,
                type: "internal"
            },
            {
                label: "Policies",
                href: Routes/* Routes.culturePolicies */.Z5.culturePolicies,
                type: "internal"
            },
            {
                label: "Air merch",
                href: Routes/* Routes.airShop */.Z5.airShop,
                type: "external"
            }, 
        ],
        css: {
            order: 5
        }
    }, 
];
var FOOTER_SOCIAL_NAVIGATION = [
    {
        href: Routes/* SocialMediaRoutes.tiktok */.aY.tiktok,
        icon: icons_esm/* Tiktok */.yAo,
        label: "TikTok"
    },
    {
        href: Routes/* SocialMediaRoutes.instagram */.aY.instagram,
        icon: icons_esm/* Instagram */.mre,
        label: "Instagram"
    },
    {
        href: Routes/* SocialMediaRoutes.twitter */.aY.twitter,
        icon: icons_esm/* Twitter */.tLe,
        label: "Twitter"
    },
    {
        href: Routes/* SocialMediaRoutes.linkedIn */.aY.linkedIn,
        icon: icons_esm/* LinkedIn */.yhk,
        label: "LinkedIn"
    },
    {
        href: Routes/* SocialMediaRoutes.youtube */.aY.youtube,
        icon: icons_esm/* YouTube */._F3,
        label: "YouTube"
    }, 
];


/***/ }),

/***/ 50580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E_": function() { return /* binding */ HEADER_MENU_ITEM_ADORNMENT; },
/* harmony export */   "Zj": function() { return /* binding */ LINK; },
/* harmony export */   "iP": function() { return /* binding */ HEADER_MENU_ITEM; },
/* harmony export */   "kW": function() { return /* binding */ HEADER_MENU; },
/* harmony export */   "lW": function() { return /* binding */ FOOTER; },
/* harmony export */   "rr": function() { return /* binding */ HEADER_NAVIGATION_ITEM; },
/* harmony export */   "tx": function() { return /* binding */ HEADER_NAVIGATION_BUTTON; },
/* harmony export */   "us": function() { return /* binding */ LOGO; },
/* harmony export */   "xD": function() { return /* binding */ HEADER_MENU_BACKGROUND; },
/* harmony export */   "yf": function() { return /* binding */ HEADER; }
/* harmony export */ });
/* unused harmony exports HEADER_MOBILE_HAMBURGER, HEADER_NAVIGATION */
var FOOTER = "FOOTER";
var HEADER = "HEADER";
var HEADER_MENU = "HEADER_MENU";
var HEADER_MENU_BACKGROUND = "HEADER_MENU_BACKGROUND";
var HEADER_MENU_ITEM = "HEADER_MENU_ITEM";
var HEADER_MENU_ITEM_ADORNMENT = "HEADER_MENU_ITEM_ADORNMENT";
var HEADER_MOBILE_HAMBURGER = "HEADER_MOBILE_HAMBURGER";
var HEADER_NAVIGATION = "HEADER_NAVIGATION";
var HEADER_NAVIGATION_ITEM = "HEADER_NAVIGATION_ITEM";
var HEADER_NAVIGATION_BUTTON = "HEADER_NAVIGATION_BUTTON";
var LINK = "LINK";
var LOGO = "LOGO";


/***/ })

}]);